import Layout from "../Layout/Layout";
import { StyledCareer } from "./Career.Styled";
import heroImage from "../../assets/image/career/hero.jpg";
import { useSelector } from "react-redux";
import props from "../../redux/props";
import History from "./History/History";
import Boxes from "./Boxes/Boxes";
import Reasons from "./Reasons/Reasons";
import Banner from "./Banner/Banner";
import People from "./People/People";
import OpenPositions from "./OpenPositions/OpenPositions";
import Wires from "./Wires/Wires";
import Hero from "../SubComponents/Hero/Hero";
import { Helmet } from "react-helmet";

const Career = () => {
  const translation = useSelector((s) => s[props.TRANSLATION]);

  return (
    <Layout authRequired={false}>
      <StyledCareer>
        <Helmet>
          <title>Berliner Glasfaserkabel GmbH</title>
          <meta
            name="description"
            content="Die Berliner Glasfaserkabel GmbH ist ein deutscher Hersteller von Glasfaserkabeln made in Germany. Erfahre warum es sich lohnt, ein Teil des Teams zu werden."
          />
          <meta name="robots" content="index, follow" />
          <meta name="author" content="Berliner Glasfaserkabel GmbH" />
          <meta httpEquiv="content-language" content="de" />
        </Helmet>
        <Hero
          title={translation.career.title}
          by={translation.career.by}
          bg={heroImage}
          top
        />
        <Boxes />
        <History />
        <Wires />
        <Reasons />
        <Banner />
        <People />
        <OpenPositions />
      </StyledCareer>
    </Layout>
  );
};

export default Career;
